<template>
  <form class="order-quote-form">
    <div class="row content-scroll">
      <div class="col-12 col-sm-6">
        <div class="form-group" :class="formGroupClass('name')">
          <label>
            {{ $t('firstAndLastName') }}
            <sup>*</sup>
          </label>
          <input
            type="text"
            class="form-control"
            name="name"
            v-validate="'required'"
            :value="form.name"
            @input="ev => handleInput('name', ev)"
          >
          <label class="text-error" v-if="errors.has('name')">
            {{ errors.first('name') }}
          </label>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group" :class="formGroupClass('email')">
          <label>
            {{ $t('email') }}
            <sup>*</sup>
          </label>
          <input
            type="email"
            class="form-control"
            name="email"
            v-validate="'required|email'"
            :value="form.email"
            @input="ev => handleInput('email', ev)"
          >
          <label class="text-error" v-if="errors.has('email')">
            {{ errors.first('email') }}
          </label>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group" :class="formGroupClass('phone')">
          <label>
            {{ $t('phone') }}
            <sup>*</sup>
          </label>
          <input
            class="form-control"
            type="text"
            name="phone"
            v-validate="'required'"
            :value="form.phone"
            @input="ev => handleInput('phone', ev)"
          >
          <label class="text-error" v-if="errors.has('phone')">
            {{ errors.first('phone') }}
          </label>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group" :class="formGroupClass('city')">
          <label>
            {{ $t('place') }}
            <sup>*</sup>
          </label>
          <input
            class="form-control"
            type="text"
            name="city"
            v-validate="'required'"
            :value="form.city"
            @input="ev => handleInput('city', ev)"
          >
          <label class="text-error" v-if="errors.has('city')">
            {{ errors.first('city') }}
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label>{{ $t('comment') }}</label>
          <textarea
            class="form-control"
            name="comment"
            :value="form.comment"
            :placeholder="$t('commentPlaceholder')"
            @input="ev => handleInput('comment', ev)"
          ></textarea>
        </div>
      </div>
      <div class="col-12">
        <div
          class="checkbox checkbox--white"
          :class="formGroupClass('agreement')"
        >
          <input
            class="checkbox__input"
            type="checkbox"
            name="agreement"
            id="orderQuote-agreement"
            v-validate="'required:true'"
            v-model="agreement"
          >
          <label
            class="checkbox__label"
            for="orderQuote-agreement"
            v-html="$t('agreement', { company: companyName})"
          ></label>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'OrderQuoteForm',
    inject: ['$validator'],
    model: {
      prop: 'form',
      event: 'update:form',
    },
    props: {
      form: {
        type: Object,
        required: true,
      },
      companyName: {
        type: String,
        required: true,
      },
    },
    methods: {
      handleInput(field, ev) {
        if (!field) {
          return;
        }

        const { form } = this;
        const newForm = Object.assign({}, form, {
          [field]: ev.target.value,
        });

        this.$emit('update:form', newForm);
      },
      formGroupClass(field) {
        const { errors } = this;

        return {
          'validate-error': !!errors.first(field),
        };
      },
    },
    computed: {
      agreement: {
        get() {
          return this.form.agreement;
        },
        set(value) {
          const { form } = this;
          this.$emit(
            'update:form',
            Object.assign({}, form, {
              agreement: value,
            }),
          );
        },
      },
    },
  };
</script>
